import styled from 'styled-components';

import { Button, colorsMatrix, Heading } from '@dreryk/react-components';

export const StyledInvoicePanelBanner = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   gap: 8px;
   height: 154px;
   width: 100%;
   padding: 32px 32px 32px 62px;
   border-radius: 20px;
   background-image: linear-gradient(
      ${(props) => props.theme.mainMenuGradientStart},
      ${(props) => props.theme.mainMenuGradientEnd}
   );
`;
StyledInvoicePanelBanner.displayName = 'StyledInvoicePanelBanner';

export const StyledInvoicePanelBannerHeading = styled(Heading)`
   color: ${colorsMatrix.grey.lightest};
`;
StyledInvoicePanelBannerHeading.displayName = 'StyledInvoicePanelBannerHeading';

export const StyledInvoicePanelBannerButton = styled(Button)`
   background: ${({ theme }) => theme.backgroundBody};
`;
StyledInvoicePanelBannerButton.displayName = 'StyledInvoicePanelBannerButton';
